import React from 'react';

const Georgia = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46480)">
      <rect width="28" height="20" rx="3" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12 12H0V8H12V0H16V8H28V12H16V20H12V12Z" fill="#F93939" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0002 14.6665H18.6668V15.9998H20.0002V17.3332H21.3335V15.9998H22.6668V14.6665H21.3335V13.3332H20.0002V14.6665ZM20.0002 3.99984H18.6668V5.33317H20.0002V6.6665H21.3335V5.33317H22.6668V3.99984H21.3335V2.6665H20.0002V3.99984ZM6.66683 3.99984H5.3335V5.33317H6.66683V6.6665H8.00016V5.33317H9.3335V3.99984H8.00016V2.6665H6.66683V3.99984ZM6.66683 14.6665H5.3335V15.9998H6.66683V17.3332H8.00016V15.9998H9.3335V14.6665H8.00016V13.3332H6.66683V14.6665Z"
        fill="#F93939"
      />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46480">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Georgia;
